import React from 'react';
import PropTypes from 'prop-types';

const IconCircle = ({ size, fill }) => {
    const r = Math.floor(size / 2);
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
            <circle cx={r} cy={r} r={r} fill={fill} />
        </svg>
    );
};

IconCircle.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconCircle.defaultProps = {
    size: 6,
    fill: '#FED700',
};

IconCircle.displayName = 'Circle';

export default IconCircle;
